export default function RegionPanel({ regions, finding }) {
  return (
    <div className="regions">
      {Object.entries(regions).map(([region, data]) => (
        <div key={region} className="region-card">
          <h3>{region}</h3>

          <p>
            AWS Config Recorder enabled:{" "}
            <b>{String(data.recorder_enabled)}</b>
          </p>

          <div className="counts">
            <span>Recorders: {data.recorders || 0}</span>
            <span>Rules: {data.rules || 0}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
